import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { OrderItem } from 'src/app/stores/stores';

@Component({
  selector: 'app-standalone-payment-item-selection',
  templateUrl: './standalone-payment-item-selection.component.html',
  styleUrls: ['./standalone-payment-item-selection.component.scss']
})
export class StandalonePaymentItemSelectionComponent implements OnInit, OnDestroy {
  destroyed$ = new Subject<void>();
  selectedItems = {};
  selectedItemsTotal = 0;
  constructor(
    public dialogRef: MatDialogRef<StandalonePaymentItemSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    let obj = {};
    if(this.data?.selectedStandalonePaymentItems) {
      this.data.selectedStandalonePaymentItems.forEach(item => {
        if(!obj[item.standalonePaymentId]) {
          obj[item.itemReference] = item;
        }
      })
    }

    if(this.data?.order?.orderItems){
      this.data.order.orderItems.forEach((item) => {
        this.selectedItems[item.uuid] = obj[item.uuid] ? obj[item.uuid].quantity : 0;
        if(obj[item.uuid] && obj[item.uuid].quantity){
          this.selectedItemsTotal += obj[item.uuid].quantity * this.calculatePerItemTotalPrice(item);
        }
      })
    }
  }

  save(): void {
    const list = [];
    if(this.data?.order?.orderItems){
      this.data.order.orderItems.forEach((item) => {
        let obj = {
          itemReference: item.uuid,
          quantity: this.selectedItems[item.uuid],
          amount: this.calculatePerItemTotalPrice(item) * this.selectedItems[item.uuid]
        };
        list.push(obj);
      })
    }
    const res = {
      items: list
    }
    this.dialogRef.close(res);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  shouldDisplayTotal() {
    if (this.data.order.orderItems) {
      for (const item of this.data.order.orderItems) {
        if (item.totalNonDiscountedPrice !== 0) { return true; }
      }
      return (this.getCartTotal() === 0) ? false : true;
    } else {
      return false;
    }
  }

  getCartTotal() {
    let ret = 0;
    if (this.data.order.orderItems) {
      this.data.order.orderItems.forEach(item => {
        ret += (item.discountType) ? item.totalDiscountedPrice : item.totalNonDiscountedPrice;
      });
    }
    return ret;
  }

  isShowParentItemPrice(orderItem: OrderItem) {
    if (orderItem.quantity > 1
      || (orderItem.discountValue !== undefined
        && orderItem.discountValue > 0)) {
      return true;
    }
    if (orderItem.childOrderItems !== undefined
      && orderItem.childOrderItems.length > 0) {
      let found = false;
      orderItem.childOrderItems.forEach(childOrderItem => {
        if (childOrderItem.offerPrice !== undefined
          && childOrderItem.offerPrice !== 0) { // Showing up the Item price if Child price is + or -
          found = true;
        }
      });
      return found;
    }
    return false;
  }

  onIncreaseItemQty(item) {
    if(this.selectedItems[item.uuid] + 1 > item.quantity){
      return;
    }
    this.selectedItems[item.uuid] += 1;
    this.selectedItemsTotal += this.calculatePerItemTotalPrice(item);
  }

  onDecreaseItemQty(item){
    if(this.selectedItems[item.uuid] - 1 < 0){
      return;
    }
    this.selectedItems[item.uuid] -= 1;
    this.selectedItemsTotal -= this.calculatePerItemTotalPrice(item);
  }

  isItemSelected(){
    if(this.selectedItems){
      for(let itemId in this.selectedItems){
        if(this.selectedItems[itemId] > 0){
          return true;
        }
      }
    }
    return false;
  }

  calculatePerItemTotalPrice(item){
    let price = item.discountedOfferPrice;
    if(item.childOrderItems){
      item.childOrderItems.forEach((childOffer) => {
        price += childOffer.quantity * childOffer.discountedOfferPrice;
      })
    }
    return price;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

}
